import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [investor, setInvestor] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("investor_user");
    if (stored) setInvestor(JSON.parse(stored));
    setIsAdmin(!!localStorage.getItem("admin_token"));
  }, []);

  const loginInvestor = (token, user) => {
    localStorage.setItem("investor_token", token);
    localStorage.setItem("investor_user", JSON.stringify(user));
    setInvestor(user);
  };

  const logoutInvestor = () => {
    localStorage.removeItem("investor_token");
    localStorage.removeItem("investor_user");
    setInvestor(null);
  };

  const loginAdmin = (token) => {
    localStorage.setItem("admin_token", token);
    setIsAdmin(true);
  };

  const logoutAdmin = () => {
    localStorage.removeItem("admin_token");
    setIsAdmin(false);
  };

  return (
    <AuthContext.Provider value={{ investor, isAdmin, loginInvestor, logoutInvestor, loginAdmin, logoutAdmin }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
